import { createAction } from 'typesafe-actions'

export const startAbort = createAction('CMD / Abort / start')()

export const configurationIsResetForAbort = createAction('EVT / Abort / configuration is reset')()

export const abortRedirect = createAction('CMD / Abort / redirect')()
